import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/billing'),
      meta: {
        appStore: true,
        permissions: [
          'administrator',
          'account_manage',
          'billing_manage',
          'lumera_app_billing_view',
        ],
      },
      component: SettingsWrapper,
      props: {
        headerTitle: 'BILLING_SETTINGS.TITLE',
        icon: 'credit-card-person',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'billing_settings_index',
          component: Index,
          meta: {
            permissions: [
              'administrator',
              'account_manage',
              'billing_manage',
              'lumera_app_billing_view',
            ],
          },
        },
      ],
    },
  ],
};
